module.exports = __webpack_public_path__ + "static/media/upload.07b36f40.svg";